module.exports = __webpack_public_path__ + "static/media/favicon.1036f409.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/favicon.png
// module id = 2778
// module chunks = 118